import { getApis } from '../../library/Apis';
import { allProfiles } from '../../library/Profiles';
import api from '../../services/api';
import { getToken } from '../../services/AuthService';
import { toRequest } from '../../utils/RequestUtils';
import { NoProfilePermissions } from './permissions/NoProfile';
import { isFirstAccess } from '../../utils/httpResponseHandlers';

export const AUTH_SET_PERMISSIONS = 'AUTH_SET_PERMISSIONS';

export const AUTH_LOADING_USER_DATA_ACTION = 'AUTH_LOADING_USER_DATA_ACTION';
export const AUTH_LOAD_USER_DATA_SUCCESS_ACTION =
  'AUTH_LOAD_USER_DATA_SUCCESS_ACTION';
export const AUTH_LOAD_USER_DATA_ERROR_ACTION =
  'AUTH_LOAD_USER_DATA_ERROR_ACTION';

export const AUTH_API_VERSION = '1';

export const getAuthApiPath = (version) => {
  return (version ? 'v' + version : 'v1') + '/token/';
};

const getUsersEndpoint = (version) => {
  return getApis().apis.users + getAuthApiPath(version);
};

const setPermissions = (userData) => {
  return (dispatch) => {
    const role = userData.perfil;
    let permissions;
    allProfiles.forEach((profile, profileIndex) => {
      if (!permissions && role && role === profile.id) {
        permissions = profile;
      }
      return profileIndex;
    });

    if (!permissions) {
      permissions = NoProfilePermissions;
    }

    dispatch({
      type: AUTH_SET_PERMISSIONS,
      payload: permissions,
    });
  };
};

export const authLoadUserData = (
  callbackSuccess,
  callbackError,
  callbackFirstAccessError
) => {
  return (dispatch) => {
    dispatch({
      type: AUTH_LOADING_USER_DATA_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [getUsersEndpoint(AUTH_API_VERSION) + getToken()],
      'authLoadUserData'
    ).then(
      (resp) => {
        dispatch(setPermissions(resp.data.dadosUsuario));
        dispatch({
          type: AUTH_LOAD_USER_DATA_SUCCESS_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: AUTH_LOADING_USER_DATA_ACTION,
          payload: true,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data.dadosUsuario);
        }
      },
      (error) => {
        dispatch({
          type: AUTH_LOAD_USER_DATA_ERROR_ACTION,
          payload: null,
        });
        dispatch({
          type: AUTH_LOADING_USER_DATA_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
        if (
          typeof callbackFirstAccessError === 'function' &&
          isFirstAccess(error.response)
        ) {
          callbackFirstAccessError(error);
        }
      }
    );
  };
};
